<div>
    <p-chart #chart type="horizontalBar" [data]="chartData" [options]="chartOptions" id="order-type-chart"></p-chart>
</div>